import { useData } from "../../runtime/provider";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getQueryKey } from "@trpc/react-query";
import { RouterInputs, RouterOutputs, trpc } from "@utils/trpc";

type Input = RouterInputs["accesses"]["getCheckoutQuote"];
type Quote = RouterOutputs["accesses"]["getCheckoutQuote"];
type Output = Exclude<Quote, { kind: "engine" }>;

export const accessCheckoutQuoteQueryKey = (input: Input) =>
  getQueryKey(trpc.accesses.getCheckoutQuote, input, "query");

export const useAccessCheckoutQuote = (
  input: Input | null,
  opts: Partial<UseQueryOptions<Quote, Error, Output | undefined>> = {},
) => {
  const data = useData();
  return useQuery({
    queryKey: input
      ? accessCheckoutQuoteQueryKey(input)
      : ["accesses", "getCheckoutQuote", "disabled"],
    queryFn: async () => {
      if (!input) {
        throw new Error("Missing checkout quote input");
      }
      return data.api.accesses.getCheckoutQuote.query(input);
    },
    select: (result) => ("kind" in result ? undefined : result),
    enabled: Boolean(input) && (opts.enabled ?? true),
    placeholderData: (previousData) => previousData,
    ...opts,
  });
};
